import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanMatch,UrlSegment,UrlTree, Route} from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { LoggedInUser } from 'src/app/models/user';
import { COOKIE_KEYS, CENTRAL_PLATFORM, STUDY_AND_ROLE_ROUTE } from '../constant/constant';
import { isNotEmptyString } from '../constant/constant-function';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate, CanMatch {

  private user: LoggedInUser | null = null;

  constructor(
    private router: Router,
    private modalService: NgbModal,
    private cookieService: CookieService
  ) {}

    canMatch(
    route: Route,
    segments: UrlSegment[]
  ): boolean | UrlTree {

    if (this.isAuthorized()) {
      return true;
    }

    this.handleUnauthorized();
    return false;
  } 

  /** Runs on every route change */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {

    if (this.isAuthorized()) {
      return true;
    }

    this.handleUnauthorized();
    return false;
  }

  /** Login check */
  isAuthorized(): boolean {

    if (window.location.href.includes(CENTRAL_PLATFORM)) {
      const role = this.cookieService.get(COOKIE_KEYS.ROLE);
      if (!role) {
        return false;
      }   
    }
    const isAuthorized = isNotEmptyString(this.cookieService.get(COOKIE_KEYS.USER_ID)) ||
      window.location.href.includes(`${STUDY_AND_ROLE_ROUTE}?code=`);

    if (!isAuthorized) {
      this.closeAllModals();
    }

    return isAuthorized;
  }

  logout(): void {
    this.user = null;

    this.closeAllModals();
    sessionStorage.clear();
    localStorage.clear();
    console.log("Cleared session and local storage on logout");
    setTimeout(() => {
      this.router.navigate([''],{ replaceUrl: true });
      window.location.reload();
    }, 1000);
  }


  private closeAllModals(): void {
    if (this.modalService.hasOpenModals()) {
      this.modalService.dismissAll('unauthorized');
    }
  }

  private handleUnauthorized(): void {
    this.closeAllModals();
    this.router.navigate([''], { replaceUrl: true });
  }
}

